import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { configAxios } from "../../../utils/ConfigAxios";
import { useNavigate } from 'react-router';
import { Avatar, CircularProgress, Chip, InputAdornment, Dialog, DialogTitle, DialogContent, DialogActions, Grid, FormControl, FormControlLabel, FormHelperText, FormGroup, IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import { external_training_list } from '../../../redux/actions/training.action';
import CancelIcon from '@mui/icons-material/Cancel';
import DatePicker from "react-datepicker";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { loadRepotingUsers, loadTrainingType } from '../../../redux/actions/lookups.action'
import Select from "react-select";
import { axiosFetch } from '../../../utils/AxiosFetch';
import moment from 'moment';
import { Close, Upload } from '@mui/icons-material';
import Dropzone from "react-dropzone";


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '1px solid #f8f8f8',
  borderRadius: "5px",
  p: 2,
  width: '800px'
};

function ExternalTrainingModal(props) {

  var remark;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [memberList, setMemberLit] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [comment, setComment] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [isFile, setIsFile] = React.useState(false);
  const [attachment, setAttachment] = React.useState(null);
  const [url, setUrl] = React.useState("");
  const [userOption, setUserOption] = React.useState([]);
  const [employee, setEmployee] = React.useState("");
  const [physicalFileName, setPhysicalFileName] = React.useState("");
  const [actualFileName, setActualFileName] = React.useState("");
  const [startDateError, setStartDateError] = React.useState(false);
  const [endDateError, setEndDateError] = React.useState(false);
  const [employeeError, setEmployeeError] = React.useState(false);
  const [isAttachment, setIsAttachment] = React.useState(true);
  const [typeError, setTypeError] = React.useState(false);
  const [trainer, setTrainer] = React.useState("");
  const [fileName, setFileName] = React.useState("");
  const [trainingTypeOption, setTrainingTypeOption] = React.useState([]);
  const [type, setType] = React.useState("")

  let LUTrainingType = useSelector(state => state.loadTrainingType_Reducer.trainingTypeList);
  let LUusersList = useSelector((state) => state.loadReportingUsers_Reducer.reportingUsers);

  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

  const handleClose = () => {
    props.handleModal();
    setMemberLit([])
    setOpen(false);
  }
  React.useEffect(() => {
    if (LUTrainingType.length > 0) {
      setTrainingTypeOption(LUTrainingType)
      if(props.data.externalTrainingType !== null && props.data.externalTrainingType !== ""){
        var selected = LUTrainingType.filter((list)=>list.label === props.data.externalTrainingType);
        setType(selected)
      }
    }
  }, [LUTrainingType, props.data])

  React.useEffect(() => {
    dispatch(loadRepotingUsers(isUserLogged.userid,true));
    dispatch(loadTrainingType());
  }, [])

  React.useEffect(() => {
    if (props.open) {
      setOpen(true);
      setLoading(false);
      setStartDateError(false);
      setEndDateError(false);
      setEmployeeError(false);
      setTypeError(false);
      if (props.edit === false) {
        handleEmpty();
      }
      else {
        fillDetail(props.data)
      }
    }
    console.log(props)
  }, [props])

  React.useEffect(() => {
    if (LUusersList.length > 0) {
      setUserOption(LUusersList)
      if (props.attendees !== "") {
        var selectedEmp = []
        props.attendees.map((id) => {
          LUusersList.map((option) => {
            if (parseInt(option.value) === parseInt(id)) {
              selectedEmp.push(option)
            }
          })
        })
        setEmployee(selectedEmp);
      }
    }
  }, [LUusersList, props.attendees])

  React.useEffect(() => {
    fillDetail(props.data)
  }, [props.data,props])

  const handleEmpty = () => {
    setTitle("");
    setDescription("");
    setStartDate("");
    setEndDate("");
    setAttachment(null);
    setIsFile(false);
    setUrl("");
    setEmployee("");
    setPhysicalFileName("");
    setActualFileName("");
    setIsAttachment(false);
    setFileName("");
    setType("");
    setTrainer("")
  }

  const fillDetail = (data) => {
    if (data !== "") {
      setTitle(data.title);
      setDescription(data.description);
      setStartDate(new Date(data.startDate));
      setEndDate(new Date(data.endDate));

      if (data.actualFileName !== "" && data.actualFileName !== null) {
        setAttachment(null)
        setIsAttachment(true);
        setFileName(data.actualFileName);
        setActualFileName(data.actualFileName);
        setPhysicalFileName(data.physicalFileName);
      }
      else {
        setIsAttachment(false);
        setFileName("");
      }
      setUrl(data.referenceUrl);
      setTrainer(data.externalTrainerName);
    }
  }
  const handleEmployee = (selected) => {
    setEmployeeError(false)
    setEmployee(selected);
  }
  ValidatorForm.addValidationRule('fileValidation', (file) => {
    if (file) {
      console.log(file)
      return false;

    }
    return true;

  });

  const handleFiles = (files) => {
    if (files.length > 0) {

      var file = files[0].name
      var accept = file.split(".").pop();
      //  
      if (accept === "doc" || accept === "pdf" || accept === "ppt" || accept === "docx") {
        setIsFile(true)
        setAttachment(files)
        const formData = new FormData();
        formData.append("file", files[0], file[0].name);
        console.log(formData)
        configAxios
          .post("/Uploads/file", formData)
          .then((res) => {
            if (res.status === 200) {
              setActualFileName(res.data[0].actualFileName);
              setPhysicalFileName(res.data[0].physicalFileName);
              setIsAttachment(true);
              setFileName(res.data[0].actualFileName);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      else {
        dispatch(SnackbarActions(true, "warning", "Attachment file type is not accepted"))

        setIsFile(false)
      }

      console.log(file.split(".").pop())
    }
    else {
      setIsFile(false)
    }
  }

  const handleRemove = () => {
    setIsFile(false);
    setAttachment(null);
    setPhysicalFileName("");
    setActualFileName("");
  }

  const handleRemovefile = () => {
    setIsAttachment(false);
    setPhysicalFileName("");
    setActualFileName("");
  }
  ValidatorForm.addValidationRule('isValidURL', (value) => {
    var pattern = /^(ftp|http|https):\/\/[^ "]+$/
    if (value !== "" && !(pattern.test(value))) {
      return false;
    }
    return true
  });

  const handleStartDate = (date) => {
    setStartDate(date)
    setEndDate("")
    setStartDateError(false)
  }

  const handleEndDate = (date) => {
    setEndDate(date)
    setEndDateError(false)
  }

  const handleTypeChange = (selected) => {
    var name = [];
    name.push(selected);
    setType(name)
    setTypeError(false)
  }

  const handleAddEdit = () => {
    console.log(employee)
    var reqUrl;
    if (type && startDate && endDate) {
      var trainingtype = type[0].value;
      setLoading(true)
      var userIds = [];
      if (employee.length > 0) {
        employee.map((option) => {
          userIds.push(option.value);
        });
      }
      var req;

      if (props.edit) {
        reqUrl = "/training/external/update";
        req = {
          "externalTraining": {
            "id": props.data.id,
            "topic": title,
            "description": description,
            "startDate": moment(startDate).format('YYYY-MM-DD'),
            "endDate": moment(endDate).format('YYYY-MM-DD'),
            "url": url,
            "physicalFileName": physicalFileName,
            "actualFileName": actualFileName,
            "externalTrainerName": trainer,
            "externalTrainingType": trainingtype,
          },
          "userIds":userIds.length>0? userIds.toString():null
        }
      }
      else {
        reqUrl = "/training/external/new";
        req = {
          "ExternalTraining": {
            "Topic": title,
            "Description": description,
            "StartDate": moment(startDate).format('YYYY-MM-DD'),
            "EndDate": moment(endDate).format('YYYY-MM-DD'),
            "Url": url,
            "PhysicalFileName": physicalFileName,
            "ActualFileName": actualFileName,
            "externalTrainerName": trainer,
            "externalTrainingType": trainingtype,
          },
          "userIds":userIds.length>0? userIds.toString():null
        }
      }
      console.log(req)

      axiosFetch({
        url: reqUrl,
        method: "post",
        requestConfig: req
      })
        .then((res) => {
          if (res.status === 200) {
            setLoading(false)
            dispatch(SnackbarActions(true, "success", props.edit === true ? "Training Updated Successfully" : "New training created succesfully"))
            handleClose();
            dispatch(external_training_list())
          }
          if (res.status === 400) {

            dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
          }
          if (res.status === 401) {
            navigate("/");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    else {
      if (startDate === "") {
        setStartDateError(true)
      }
      if (endDate === "") {
        setEndDateError(true)
      }
      // if (employee.length === 0) {
      //   setEmployeeError(true)
      // }
      if (type.length < 1) {
        setTypeError(true)
      }
    }
  }

  ValidatorForm.addValidationRule('offlineNeedName', (value) => {
    if (type.length > 0) {
      if (type[0].value === "2" && value === "") {
        return false;
      }
      return true;
    }
    return true;
  });

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {handleClose ? (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  return (
    <div>
      <Dialog
        fullWidth="md"
        maxWidth="md"

        open={open}
        onClose={handleClose}
        scroll={'paper'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <BootstrapDialogTitle id="scroll-dialog-title">
          <Typography id="modal-modal-title" sx={{ borderBottom: "1px solid #ccc" }} className='modal-heading' variant="h6" component="h2">
            {props.edit ? "Update":"Add"} External Training
          </Typography>
        </BootstrapDialogTitle>
        <DialogContent>         
          <ValidatorForm onSubmit={() => handleAddEdit()}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextValidator
                  id="input-with-icon-textfield"
                  variant="outlined"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  fullWidth
                  label="Training Title"
                  type="text"
                  validators={["required"]}
                  errorMessages={["Please fill out this field"]}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl sx={{ width: "100%" }}>
                  <FormControlLabel
                    control={<DatePicker
                      placeholderText="Start Date"
                      fullWidth
                      className="datetime"
                      dateFormat="MMM-dd-yyyy"
                      selected={startDate}
                      onSelect={(date) => handleStartDate(date)}
                    />}
                  />
                  {startDateError ? <FormHelperText className="error-message">Please fill out this field</FormHelperText> : ""}

                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl sx={{ width: "100%" }}>
                  <FormControlLabel
                    control={<DatePicker
                      placeholderText="End Date"
                      fullWidth
                      className="datetime"
                      dateFormat="MMM-dd-yyyy"
                      selected={endDate}
                      onSelect={(date) => handleEndDate(date)}
                    />}
                  />
                  {endDateError ? <FormHelperText className="error-message">Please fill out this field</FormHelperText> : ""}

                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  id="input-with-icon-textfield"
                  variant="outlined"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  fullWidth
                  label="Training Description"
                  type="text"
                  rows={3}
                  multiline
                />
              </Grid>
              <Grid item xs={4}>
                {isAttachment ?
                  <>
                    <span>Attachment</span>
                    <Chip color="primary" label={fileName} onDelete={handleRemovefile} />

                  </>
                  :
                  <><Dropzone
                disableClick={true}
                onDrop={(e) => handleFiles(e)}
                className="dropzone"
                activeClassName="active-dropzone"
                multiple={false}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div
                      {...getRootProps()}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <input {...getInputProps()} />

                      <p style={{border:"1px solid #cccccc",marginTop:1,textAlign:"center",borderRadius:"4px", color:"#666666"}}>
                       
                        Drag your file here  -- OR --
                        <br />
                        <Upload />Upload from Computer
                      </p>

                    </div>
                  </section>
                )}

              </Dropzone>
              <FormHelperText>Accepted file types are *pdf, *doc, *ppt, *docx</FormHelperText>

              </>
                  //  <TextValidator
                  //   type='file'
                  //   onChange={(e) => handleFiles(e)}
                  //   // value={attachment}
                  //   InputProps={{
                  //     endAdornment: (
                  //       <InputAdornment className="eye-icon">
                  //         {isFile ? <CancelIcon onClick={() => handleRemove()} /> : ""}
                  //       </InputAdornment>
                  //     ),
                  //   }}
                  //   helperText="Accepted file types are *pdf, *doc *ppt"
                  // />
                  }
              </Grid>
              <Grid item xs={4}>
                <TextValidator
                  id="input-with-icon-textfield"
                  variant="outlined"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  fullWidth
                  label="Reference URL"
                  type="url"
                  validators={["isValidURL"]}
                  errorMessages={["Enter valid url"]}
                />
              </Grid>
              <Grid item xs={4}>
                <Select
                  menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  isMulti="true"
                  placeholder={<div>Select Attendees</div>}
                  options={userOption}
                  value={employee}
                  onChange={handleEmployee}
                />
                {employeeError ? <FormHelperText className="error-message">Please choose employee for this training</FormHelperText> : ""}
              </Grid>
              <Grid item xs={4}>
                <h3 className="input-head">Training Type</h3>
                <FormControl sx={{ width: "100%" }}>
                  <FormGroup>
                    <FormControlLabel className="type"
                      control={<Select
                        className="training-select"
                        value={type}
                        options={trainingTypeOption}
                        onChange={handleTypeChange}
                        menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />}
                    />
                  </FormGroup>
                  {typeError ? <FormHelperText className="error-message">Please fill out this field</FormHelperText> : ""}
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <h3 className="input-head">Trainer Name</h3>
                <TextValidator
                  id="input-with-icon-textfield"
                  variant="outlined"
                  value={trainer}
                  onChange={(e) => setTrainer(e.target.value)}
                  fullWidth
                  label="Trainer Name"
                  type="text"
                  validators={["offlineNeedName"]}
                  errorMessages={["Please fill out this field"]}
                />
              </Grid>
            </Grid>
            <Button className="theme-btn cancel-btn" variant="contained" onClick={() => handleClose()}>Cancel</Button>

            {loading ? <CircularProgress sx={{ float: "right", marginRight: 1 }} fontSize="small" /> :
              <Button className='theme-btn' type='submit' variant="outlined" sx={{ float: "right", marginRight: 1 }}>{props.edit ? "update" : "Submit"}</Button>
            }
          </ValidatorForm>
        </DialogContent>
      </Dialog>

    </div>
  )
}
export default ExternalTrainingModal;